import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import {
  observationParentCaseBannerSentence,
  openParentCaseButtonLabel,
} from '../../domain/incidents/observationDispositionCopy';

export type ParentPatternCaseBannerProps = {
  observationCount: number;
  patternLabel?: string | null;
  parentCaseIncidentId?: string | null;
  onOpenParentCase?: (incidentId: string) => void;
};

export const ParentPatternCaseBanner: React.FC<ParentPatternCaseBannerProps> = ({
  observationCount,
  patternLabel,
  parentCaseIncidentId,
  onOpenParentCase,
}) => {
  const parentId = String(parentCaseIncidentId || '').trim();
  return (
    <Alert
      severity="info"
      sx={{ mb: 2, borderRadius: 2.5 }}
      data-testid="parent-pattern-case-banner"
      action={
        parentId && onOpenParentCase ? (
          <Button
            color="inherit"
            size="small"
            variant="outlined"
            onClick={() => onOpenParentCase(parentId)}
          >
            {openParentCaseButtonLabel()}
          </Button>
        ) : undefined
      }
    >
      <Typography variant="body2" sx={{ lineHeight: 1.55 }}>
        {observationParentCaseBannerSentence(observationCount, patternLabel)}
      </Typography>
    </Alert>
  );
};

export type ObservationDispositionHeaderProps = {
  locationLine: string;
  incidentId: string;
  observedAtLabel: string;
};

export const ObservationDispositionHeader: React.FC<ObservationDispositionHeaderProps> = ({
  locationLine,
  incidentId,
  observedAtLabel,
}) => (
  <Box data-testid="observation-disposition-header" sx={{ mb: 0.5 }}>
    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.55 }}>
      {locationLine}
    </Typography>
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.35 }}>
      {[incidentId, observedAtLabel].filter(Boolean).join(' · ')}
    </Typography>
  </Box>
);
